import { render, staticRenderFns } from "./EditContentModal.vue?vue&type=template&id=4037e304&"
import script from "./EditContentModal.vue?vue&type=script&lang=js&"
export * from "./EditContentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports